/**
 * wordWrap된 줄 배열을 maxLines로 자르고 초과 시 말줄임(…)을 붙이는 순수 함수 (런타임 최후 방어, 방안 B).
 *
 * Phaser Text.getWrappedText() 결과(줄 배열)를 받아, 박스 세로를 넘는 줄을 잘라 **어떤 데이터·언어가 와도**
 * 세로 오버플로를 막는다. 정적 게이트(textOverflow.test, 방안 C)가 데이터 길이를 보증하고,
 * 이 함수가 표시를 보증하는 이중 안전망 — C가 놓친 케이스(새 언어·런타임 조합)를 B가 흡수한다.
 */
/**
 * @param lines - `Phaser.GameObjects.Text.getWrappedText()` 반환값(줄 배열).
 * @param maxLines - 허용 최대 줄 수. 0 이하이면 빈 문자열 반환.
 * @returns 표시할 최종 문자열. 초과 시 마지막 줄에 `…` 부착.
 */
export function clampWrappedLines(lines: readonly string[], maxLines: number): string {
  if (maxLines <= 0) return "";
  if (lines.length <= maxLines) return lines.join("\n");
  const kept = lines.slice(0, maxLines);
  // 마지막 줄에 말줄임 표시 — 더 있음을 알린다(잘린 줄은 화면 밖).
  kept[maxLines - 1] = (kept[maxLines - 1] ?? "") + "…";
  return kept.join("\n");
}
